import cloneDeep from 'lodash/cloneDeep';
var config = cloneDeep(Object.assign({}, window.Config));
export default config;
